var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
  pluginRegistry.registerDeploymentAction("Octopus.Email", function(octopusRepository, busy) {
    return {
      executionLocation: actionExecutionLocations.alwaysOnServer,
      canChooseRoles: false,
      canHaveChildren: function() { return false; },
      canBeChild: true,
      hasPackages: function(action) { return false; },
            summaryTemplateUrl: "areas/projects/actions/Octopus.Email_summary.html",
            editTemplateUrl: "areas/projects/actions/Octopus.Email_edit.html",
            editLink: function ($scope, element, action) {
                var isLoading = $scope.isLoading = busy.create();

                var hasCCBcc = false;
                if (action.Properties["Octopus.Action.Email.CC"]
                    || action.Properties["Octopus.Action.Email.CCTeamIds"]
                    || action.Properties["Octopus.Action.Email.Bcc"]
                    || action.Properties["Octopus.Action.Email.BccTeamIds"]) {
                    hasCCBcc = true;
                }
                $scope.email = {showCCBcc: hasCCBcc};
                $scope.showCCBcc = function () {
                    $scope.email.showCCBcc = true;
                };

                $scope.selectedToTeamIds = [];
                $scope.selectedCcTeamIds = [];
                $scope.selectedBccTeamIds = [];
                $scope.onChange = function () {
                    action.Properties["Octopus.Action.Email.ToTeamIds"] = $scope.selectedToTeamIds.reduce(function (prev, team) {
                        return (prev ? (prev + ',') : '') + team;
                    });
                    action.Properties["Octopus.Action.Email.CCTeamIds"] = $scope.selectedCcTeamIds.reduce(function (prev, team) {
                        return (prev ? (prev + ',') : '') + team;
                    });
                    action.Properties["Octopus.Action.Email.BccTeamIds"] = $scope.selectedBccTeamIds.reduce(function (prev, team) {
                        return (prev ? (prev + ',') : '') + team;
                    });
                };
                $scope.$watch(function () {
                    return action.Properties["Octopus.Action.Email.ToTeamIds"];
                }, function () {
                    $scope.selectedToTeamIds = (action.Properties["Octopus.Action.Email.ToTeamIds"] || '').split(',');
                });
                $scope.$watch(function () {
                    return action.Properties["Octopus.Action.Email.CCTeamIds"];
                }, function () {
                    $scope.selectedCcTeamIds = (action.Properties["Octopus.Action.Email.CCTeamIds"] || '').split(',');
                });
                $scope.$watch(function () {
                    return action.Properties["Octopus.Action.Email.BccTeamIds"];
                }, function () {
                    $scope.selectedBccTeamIds = (action.Properties["Octopus.Action.Email.BccTeamIds"] || '').split(',');
                });

                isLoading.promise(octopusRepository.Teams.all().then(function (teams) {
                    $scope.teams = teams;
                }));
            },
            summaryLink: function ($scope, element, action) {
                var isLoading = $scope.isLoading = busy.create();
                var getTags = function(allOptions, selectedOptions) {
                    if (allOptions.length === 0) {
                        return "";
                    }
                    var result = [];
                    _.each(selectedOptions, function (e) {
                        if (allOptions.indexOf(e.Id) >= 0) {
                            result.push(e.Name);
                        }
                    });
                    return result.join(",");
                };

                isLoading.promise(octopusRepository.Teams.all().then(function (teams) {
                    $scope.teams = teams;
                    if ($scope.action.Properties["Octopus.Action.Email.ToTeamIds"] !== undefined) {
                        $scope.emailTeams = getTags($scope.action.Properties["Octopus.Action.Email.ToTeamIds"], teams);
                    }
                }));
            }
        };
    });
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/Octopus.Email.js
// module id = 478
// module chunks = 1